
export default class ShopIndex {
    constructor($view) {
        this.bind();
    }

    bind()
    {

        // Initialisation de l'action au lorsque la page est complètement chargée
        HegydStoreLocator.initGeolocatorOnPageReady();

        // Initialisation de l'action au clic sur la cible dans le champs de recherche
        HegydStoreLocator.initGeolocatorOnClick();

        // Initialisation du champ autocomplete
        HegydStoreLocator.initAutocompleteSearch();

        $('.show-our-shops').on('click',function (e) {
            e.preventDefault();
            $('.our-shops').show();
            $(this).hide();
            $('.hide-our-shops').show();
        });

        $('.hide-our-shops').on('click',function (e) {
            e.preventDefault();
            $('.our-shops').hide();
            $('.show-our-shops').show();
            $(this).hide();
        });

    }
}
